/**
 * throttle - Limits function execution rate
 * @param {Function} fn   - Function to throttle
 * @param {number}   time - Minimum time between executions (ms)
 * @return {Function} Throttled function
 */
const throttle = (fn, time) => {
  let timeout = null;
  return function () {
    if (timeout) {
      return;
    }
    const context = this;
    const args = arguments;
    const later = () => {
      fn.call(context, ...args);
      timeout = null;
    };
    timeout = setTimeout(later, time);
  };
};

export default throttle;
